import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { useSocialLinks } from "../../hooks/useSocialLinks";
import { SOCIAL_ICONS, SOCIAL_NAMES } from "../../constants/socialIcons";

const SocialFollowSection = () => {
  const { language } = useLanguage();
  const { socialLinks } = useSocialLinks();

  const enabledLinks = Object.entries(socialLinks).filter(([_, data]) => data?.enabled && data?.url);

  if (enabledLinks.length === 0) return null;

  return (
    <section className="py-8 bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-500" data-testid="social-follow-section">
      <div className="calli-container">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
          <p className="text-white font-bold text-lg">
            {language === 'fr' ? '📱 Rejoignez la communauté Calli !' : '📱 Join the Calli community!'}
          </p>
          <div className="flex items-center gap-3">
            {enabledLinks.map(([key, data]) => (
              <a
                key={key}
                href={data.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 bg-white/20 hover:bg-white text-white hover:text-orange-500 px-4 py-2 rounded-full font-medium transition-all duration-300 hover:scale-105"
                data-testid={`social-top-${key}`}
                title={SOCIAL_NAMES[key]}
              >
                {SOCIAL_ICONS[key]}
                <span className="hidden sm:inline text-sm">{SOCIAL_NAMES[key]}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialFollowSection;
